
class OurServicesList {

    mq = null
    items = null

    constructor( list ){

        this.mq = window.matchMedia( '(max-width: 1024px)' )
        this.items = list.querySelectorAll( ':scope > li' )

        for( const item of this.items ){
            const header = item.querySelector( ':scope > header' )
            if( header ){
                header.addEventListener( 'click', () => this.onHeaderClick( item ) )
            }
        }

        this.mq.addEventListener( 'change', () => this.closeAll() )

    }

    onHeaderClick( item ){

        if( !this.mq.matches ) return

        const isOpen = item.classList.contains( 'is-open' )
        this.closeAll()

        if( !isOpen ){
            item.classList.add( 'is-open' )
        }

    }

    closeAll(){
        for( const item of this.items ){
            item.classList.remove( 'is-open' )
        }
    }

}

const initOurServicesLists = () => {
    const lists = document.querySelectorAll( '.our-services .texts ul' )
    for( const list of lists ){
        new OurServicesList( list )
    }
}

window.addEventListener( 'DOMContentLoaded', () => {
    initOurServicesLists()
})
